import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=1094a233&scoped=true&"
import script from "./agreement.vue?vue&type=script&lang=js&"
export * from "./agreement.vue?vue&type=script&lang=js&"
import style0 from "./agreement.vue?vue&type=style&index=0&lang=css&"
import style1 from "./agreement.vue?vue&type=style&index=1&id=1094a233&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1094a233",
  null
  
)

export default component.exports